import React from "react";
import "../styles/Portfolio.css";
import { NavLink } from "react-router-dom";
import HandsOn from "../assets/home/handson.svg";
import CompletedProjects from "../assets/home/completedprojects.svg";
import BrandsWroked from "../assets/home/brandsworked.png";
import Projects from "../assets/home/projects.svg";
import ClientsSatisfied from "../assets/home/clientssatisfied.svg";
import DigitalExperience from "../assets/home/digitalexperience.svg";

export default function Portfolio() {
  return (
    <div className="portfolio">
      <div className="portfolio-header">
        <h1>
          I Craft <span> Innovative </span> Product Solutions.
        </h1>
      </div>
      <div className="portfolio-body">
        <div className="portfolio-body-left">
          <div className="portfolio-body-left-top">
            <img src={CompletedProjects} alt="Completed Projects" />
            <img src={HandsOn} alt="Hands On" />
          </div>
          <div className="portfolio-body-left-bottom">
            <img src={ClientsSatisfied} alt="Clients Satisfied" />
            <img src={DigitalExperience} alt="Digital Experience" />
          </div>
        </div>
        <div className="portfolio-body-right">
          <h1>About Me</h1>
          <p>
            I am a UI/UX designer with six years of experience in creating
            engaging and easy-to-use digital experiences.
          </p>
          <p>
            Throughout my career, I have worked on a wide range of projects
            across various industries, including tech startups, and SaaS
            platform. My approach is rooted in user-centered design principles,
            ensuring that every project. I undertake is informed by real user
            insights and data. I am skilled in the entire design process, from
            initial research and wire-framing to high-fidelity prototyping and
            usability testing.
          </p>
          <NavLink to="/about" className="read-more-link">
            Read More <span>&gt;</span>
          </NavLink>
        </div>
      </div>
      <div className="portfolio-body">
        <div className="portfolio-body-left-second">
          <h1>My Projects</h1>
          <NavLink to="/portfolio" className="read-more-link">
            View All <span>&gt;</span>
          </NavLink>
          <img src={Projects} alt="Projects" />
        </div>
        <div className="portfolio-body-right">
          <h1>Brands I Worked With</h1>
          <img src={BrandsWroked} alt="Brands Worked" />
        </div>
      </div>
    </div>
  );
}
